import { useState } from 'react'

import { useAuthStore } from '@/store/auth-store'
import { Role } from '@/types/auth'
import { AreaSelect } from '@/modules/Areas/ui/AreasSelect'
import { GarageSelect } from '@/modules/FindGarage'
import { FlaggedRecordsTable } from './components/FlaggedRecordsTable'
import { ShowingDropdown, DateRange } from './components/ShowingDropdown'
import {
    DEFAULT_SHOWING_OPTION,
    DEFAULT_SHOWING_OPTION_BY_ROLE,
    ShowingOption,
    SHOWING_OPTIONS_BY_ROLE,
} from '../config/showingOptions'

import styles from './FlaggedRecords.module.scss'

export const FlaggedRecords = () => {
    const { role } = useAuthStore()
    const [newestFirst, setNewestFirst] = useState(false)
    const defaultOption = (role && DEFAULT_SHOWING_OPTION_BY_ROLE[role]) ?? DEFAULT_SHOWING_OPTION
    const [selectedOption, setSelectedOption] = useState<ShowingOption>(defaultOption)
    const [dateRange, setDateRange] = useState<DateRange>({ from: null, to: null })

    const options = (role && SHOWING_OPTIONS_BY_ROLE[role]) ?? [DEFAULT_SHOWING_OPTION]

    return (
        <section className={styles.root}>
            <header className={styles.header}>
                <h1 className={styles.title}>
                    {role === Role.PerformanceManager && <AreaSelect />}
                    {role === Role.MileageClerk && <GarageSelect />}
                </h1>
                <ShowingDropdown
                    newestFirst={newestFirst}
                    onToggleSort={() => setNewestFirst((p) => !p)}
                    options={options}
                    selectedOption={selectedOption}
                    onSelectOption={setSelectedOption}
                    dateRange={dateRange}
                    onDateRangeChange={setDateRange}
                />
            </header>
            <div className={styles.container}>
                <FlaggedRecordsTable
                    newestFirst={newestFirst}
                    selectedDays={selectedOption.days}
                    dateRange={dateRange}
                />
            </div>
        </section>
    )
}
